import cx from 'classnames';
import { Heading, Pill, enums, Icon, utils as u } from 'edrolo-ui';
import {
  InteractiveActivityChunk,
  Lesson,
} from '../../../../../../types/Assemblage';
import urlResolver from 'edrolo/utils/URLResolver';
import { Link } from 'react-router-dom';
import { ClassContext, UserContext } from 'edrolo/context';
import { useContext } from 'react';
import { useAnalytics } from 'edrolo/analytics';
import s from './styles.scss';

export interface InteractiveActivityCardProps {
  chunk: InteractiveActivityChunk;
  lesson: Lesson;
}

export const InteractiveActivityCard = ({
  chunk,
  lesson,
}: InteractiveActivityCardProps) => {
  const { profile } = useContext(UserContext);
  const {
    data: { classId },
  } = useContext(ClassContext);

  const disabled = lesson.is_coming_soon && !profile.is_staff;

  const url = urlResolver.reverse('chunkview-chunk', {
    lessonId: lesson.id,
    classId,
    index: chunk.index,
  });

  const { track: analyticsTrack } = useAnalytics({});

  const handleClick = (e: React.MouseEvent) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    analyticsTrack('interactive activity card clicked', {
      interactive_activity_id: chunk.interactive_activity.id,
    });
  };

  return (
    <div
      className={cx(s.interactiveActivityCard, {
        [s.highlight]: !lesson.is_published,
      })}
      data-appcues="interactive-activity-card"
    >
      <header>
        <Link
          to={url}
          className={cx({ [s.disabled]: disabled })}
          onClick={handleClick}
          aria-disabled={disabled || undefined}
          tabIndex={disabled ? -1 : undefined}
        >
          <Pill variant={enums.PillVariant.FADE} color={enums.ColorHue.TEAL}>
            <Icon
              name={enums.Icons.BOX}
              color={enums.ColorHue.TEAL}
              className={u.mr1}
            />
            Simulation
          </Pill>
        </Link>

        <Link
          to={url}
          className={cx({ [s.disabled]: disabled })}
          onClick={handleClick}
          aria-disabled={disabled || undefined}
          tabIndex={disabled ? -1 : undefined}
        >
          <Heading level={4} className={u.bold}>
            {chunk.interactive_activity.name}
          </Heading>
        </Link>

        {lesson.is_coming_soon && (
          <Pill color={enums.ColorHue.GREY}>Coming soon</Pill>
        )}
        {!lesson.is_published && (
          <Pill color={enums.ColorHue.GREY}>Unpublished</Pill>
        )}
      </header>
    </div>
  );
};
